import { useEffect, useState } from "react";
import api, { formatBRL, formatCPF } from "@/lib/api";
import { Users, Plus, X } from "lucide-react";
import { toast } from "sonner";

export default function GestorClientes() {
  const [users, setUsers] = useState([]);
  // simple endpoint via leads/atendimentos; for now we'll fetch users via dashboard kpis count placeholder
  // Instead we'll list invoices grouped by user. We'll use direct fetch from /api by reusing list_clients endpoint we add later.
  // For MVP: show invoices summary per cliente.
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    api.get("/invoices").then(r => setInvoices(r.data)).catch(()=>{});
  }, []);

  return (
    <div className="space-y-6" data-testid="gestor-clientes-page">
      <div>
        <h1 className="font-display text-3xl font-black text-[#0E2A5C] flex items-center gap-2"><Users className="h-7 w-7" /> Clientes & Faturas</h1>
        <p className="text-sm text-slate-500">Visão consolidada de cobrança</p>
      </div>

      <div className="card-soft overflow-hidden">
        <table className="w-full text-sm" data-testid="invoices-admin-table">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Descrição</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Vencimento</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Valor</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Método</th>
              <th className="px-5 py-3 font-bold text-[#0E2A5C]">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {invoices.map(inv => (
              <tr key={inv.id} data-testid={`invoice-row-${inv.id}`}>
                <td className="px-5 py-3 font-semibold text-[#0E2A5C]">{inv.description}</td>
                <td className="px-5 py-3">{new Date(inv.due_date).toLocaleDateString("pt-BR")}</td>
                <td className="px-5 py-3 font-bold">{formatBRL(inv.amount)}</td>
                <td className="px-5 py-3 uppercase text-xs">{inv.method}</td>
                <td className="px-5 py-3">
                  {inv.status === "pago"
                    ? <span className="text-xs font-bold px-3 py-1 rounded-full bg-emerald-50 text-emerald-700">Pago</span>
                    : <span className="text-xs font-bold px-3 py-1 rounded-full bg-amber-50 text-amber-700">Pendente</span>}
                </td>
              </tr>
            ))}
            {invoices.length === 0 && (
              <tr><td colSpan={5} className="text-center py-10 text-slate-500">Nenhuma fatura registrada.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
